/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import ElectroMessageBarCont from 'forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import ElectroSelectWithOther from 'forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveOwnedAssetForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, asset, form }: TypeProps = this.props;

    const details: Array<Array> = [
      [t('general:trading_account'), `${asset.account.name} ${asset.account.number}`],
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    const diff: number = asset.project
      ? moment(asset.project.end_date.date).diff(moment(new Date()), 'days')
      : null;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
            {diff > 0 ? (
              <ElectroMessageBarCont
                props={{
                  linkto: `/projects/${asset.project.id}`,
                  variant: 'warning',
                  message: t('general:assets.messages.still_in_use'),
                }}
              />
            ) : null}
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.currently_assigned_to')}
          >
            <ul>
              <li>{asset.user.name}</li>
              <li>{`${t('general:roles.labels.current_role')}: ${asset.user.role}`}</li>
            </ul>
          </ActionDrawerBlock>
          <ActionDrawerBlock gutters={true} heading={form.$('archiveReason').label}>
            <ElectroSelectWithOther
              field={form.$('archiveReason.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.archive_asset')} />
      </React.Fragment>
    );
  }
}
